/* テンプレート表示画面 */
import React, { useState, useEffect } from 'react';
import { handleBrowzerBack } from '../BrowzerBack';
import Text from '../molecules/Text';
import axios from '../axios';
import Moment from 'moment';
import ShelfInShelf from '../molecules/ShelfInShelf';
import Shelf from '../molecules/Shelf';
import { ParentShelf, ChildShelf, Content } from '../types/Template';
import RowDate from '../molecules/RowDate';
import Postcode from '../molecules/Postcode';
import Telnum from '../molecules/TelInput';
import NameInput from '../molecules/NameInput';
import RadioButton from '../molecules/RadioButton';
import CheckBox from '../molecules/CheckBox';
import Select from '../molecules/Select';
import TopArea from '../molecules/TopArea';
import TextArea from '../molecules/TextArea';
import Paragraph from '../molecules/Paragraph';
import EnclosedString from '../molecules/EnclosedString';
import LayoutDivision from '../molecules/LayoutDivision';
import YearMonth from '../molecules/InputYearMonth';
import Image from '../molecules/Image';
import RowFullJustifyButton from '../molecules/RowFullJustifyButton';
import RowJustifyButton from '../molecules/RowJustifyButton';
import RowLeftButton from '../molecules/RowLeftButton';
import RowRightButton from '../molecules/RowRightButton';
import RowCenterButton from '../molecules/RowCenterButton';
import FileUploadTemplate from '../organisms/FileUpload';
import { FileUpload } from '../types/FileUpload';
import FooterButtonShelf from '../molecules/FooterAreaButtons';
import BusinessDayCalendar from '../organisms/BusinessDayCalendar';
import NoLabelTextarea from '../molecules/NoLabelTextarea';
import NoLabelCheckBox from '../molecules/NoLabelCheckBox';
import ShelfHeading from '../molecules/ShelfHeading';
import Clause from '../molecules/Clause';
import CenterParagraph from '../molecules/CenterParagraph';
import { tmp_init, convert_types, shelf_type, fm_types, item_init, address_init } from '../Const';
import { isBrowserIe } from '../BrowserJudgment';
import LoadingModal from '../molecules/LoadingModal';
import RowLeftAndRightAlignmentButton from '../molecules/RowLeftAndRightAlignmentButton';
import RowLeftAndCenterAlignmentButton from '../molecules/RowLeftAndCenterAlignmentButton';
import { createRoot } from 'react-dom/client';
import TextWithSearch from '../molecules/TextWithSearch';

const ReceptionDetail: React.FC = () => {
  // 親棚の状態
  const [parent_shelfs, setParentShelfs] = useState<ParentShelf[]>([]);
  // 子棚の状態
  const [child_shelfs, setChildShelfs] = useState<ChildShelf[]>([]);
  // 小棚内要素の状態
  const [contents, setContents] = useState<Content[]>([]);
  const [upload_token, setUploadToken] = useState<string>('');
  // ヘッダーに表示する情報
  const [reception_cd, setReceptionCd] = useState('');
  const [reception_sub_cd, setReceptionSubCd] = useState('');
  const [status, setStatus] = useState('');
  const [status_code, setStatusCode] = useState(0);
  const [email, setEmail] = useState('');
  const [is_staff, setIsStaff] = useState(false);
  const [reception_id, setReceptionId] = useState(0);
  const [application_date, setApplicationDate] = useState('');
  const [application_product, setApplicationProduct] = useState('');
  const [user_name, setUserName] = useState('');
  const [user_kana_name, setUserKanaName] = useState('');
  const [mypage_status_opened, setMypageStatusOpened] = useState(false);
  const [message, setMessage] = useState('');
  const [ident_lv1_cd, setIdentLv1Cd] = useState('');
  const [ident_lv2_cd, setIdentLv2Cd] = useState('');
  const [ident_lv3_cd, setIdentLv3Cd] = useState('');
  const [desired_amount_before, setDesiredAmountBefore] = useState('');
  const [desired_amount_application, setDesiredApplication] = useState('');
  const [desired_amount_after, setDesiredAmountAfter] = useState('');

  // 提出済み本人確認書類リスト
  const [file_upload_list, setFileUploadList] = useState<FileUpload[]>([]);

  // 住所選択状態
  const [address_state, setAddressState] = useState(address_init);
  // 検索項目つきテキストボックスの項目選択状態
  const [text_with_search_state, setTextWithSearchState] = useState(item_init);
  // Ajax通信状態
  const [is_connecting, setIsConnecting] = useState(false);
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);
  // onChange発火フラグ
  const [is_on_change, setIsOnChange] = useState(false);

  const [isClickConfirm, setIsClickConfirm] = useState(false);
  const isConfirmMode = true;

  const disableAllContents = (contents: Content[]) => {
    return contents?.reduce<Content[]>((prev, curr) => [...prev, { ...curr, disabled: true }], []);
  };

  const branchValue = contents?.find((content) => content.field_column_name === 'branch')?.value;
  const emailValue = contents?.find((content) => content.field_column_name === 'email')?.value;

  /**
   * テンプレート取得用のパスを生成する
   *
   * Note: 現在のURLからAPI取得用のURLを作成します。
   * 使用URLの変更等があった場合は修正必須です。
   * URL末尾 ⇒ reception_id 案件ID
   * URL末尾-1 ⇒ reception_cd 案件CD
   *
   * @return string テンプレート取得URL
   */
  const makePath = (): string => `api/receptions/detail/${getKeyFormUrl()}`;

  const getKeyFormUrl = () => {
    const urls = location.pathname.split('/');
    return urls.pop();
  };

  /**
   * アップロードファイルデータ取得用のパスを生成する
   *
   * Note: 現在のURLからAPI取得用のURLを作成します。
   * 使用URLの変更等があった場合は修正必須です。
   * URL末尾 ⇒ reception_id 案件ID
   * URL末尾-1 ⇒ reception_cd 案件CD
   *
   * @return string テンプレート取得URL
   */
  const makePathFileUpload = (): string => {
    const urls = location.pathname.split('/');
    const key = urls.pop();
    return `api/receptions/confirm/${key}/file?type=reception`;
  };

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
    fetchReception(makePath());
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isConfirmMode || isClickConfirm) return;
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isConfirmMode, isClickConfirm]);

  /**
   * 案件詳細画面表示に必要なデータを再取得します。
   * エラー発生時はローディングを非表示にします。
   * @param url データ取得先url
   */
  const fetchReception = async (url: string) => {
    try {
      const response = await axios.get(url);
      setParentShelfs(response.data.info.parent_blocks);
      setChildShelfs(response.data.info.child_blocks);
      const contentWithUserSubmit: Content[] = [
        ...response.data.info.contents,
        { key: 'email', field_column_name: 'email', value: response?.data?.user_info?.email },
        {
          key: 'branch',
          field_column_name: 'branch',
          value: response?.data?.user_info?.branch,
          hidden: !response?.data?.template?.has_branch,
        },
      ];
      setContents(disableAllContents(contentWithUserSubmit));
      setMypageStatusOpened(response.data.info.mypage_status_opened);
      setFileUploadList(response.data.info.files);
      getPreview(response.data.info.files);
      setUploadToken(response.data.upload_token);
    } catch (error) {
      console.error(error);
      // エラーメッセージを表示後、案件一覧に遷移する
      alert(error.response.data.message);
      location.replace(`${location.origin}${process.env.MIX_MOCK_URL}`);
    }
  };

  /**
   * プレビュー表示する画像を非同期で取得する
   *
   * @param {Array<FileUpload>} file_upload_list ファイル情報
   */
  const getPreview = async (file_upload_list: Array<FileUpload>) => {
    // 画像情報取得データ作成
    const array = file_upload_list.map((data: FileUpload) => {
      return data.file_upload_name;
    });
    const response = await axios.post(makePathFileUpload(), array);
    // 取得結果を格納
    const result_array = file_upload_list.map((data: FileUpload, index: number) => {
      return {
        ...data,
        preview_file_src: response.data[index],
      };
    });
    setFileUploadList(result_array);
  };

  /**
   * 親の棚を作成
   * Note: 棚種別は 2, 3, 4以外不要
   * @return JSX.Element[]
   */
  const createParentBlock = () => {
    // 初期表示用条件
    return parent_shelfs.map((parent_shelf) => {
      switch (parent_shelf.pb_kind) {
        case shelf_type.shelf: // アコーディオン出力
          return (
            <Shelf
              key={parent_shelf.pb_id}
              label={parent_shelf.pb_display_name}
              is_open={parent_shelf.pb_open}
              handleClick={() => toggleParentShelf(parent_shelf.pb_id)}
            >
              {createChildBlock(parent_shelf.pb_id)}
            </Shelf>
          );
        case shelf_type.layout_divisiton: // レイアウト用論理棚
          return (
            <LayoutDivision key={parent_shelf.pb_id}>
              {createChildBlock(parent_shelf.pb_id)}
            </LayoutDivision>
          );
        case shelf_type.fragment: // domを出力しない棚
          return (
            <React.Fragment key={parent_shelf.pb_id}>
              {createChildBlock(parent_shelf.pb_id)}
            </React.Fragment>
          );
        default:
          return;
      }
    });
  };

  /**
   * 親棚を開閉する
   *
   * @param parent_id 親棚のid
   */
  const toggleParentShelf = (parent_id: number) => {
    setParentShelfs((prev) => {
      // 対象親棚のindex取得
      const current_index = prev.findIndex((value) => value.pb_id === parent_id);
      // ディープコピー
      const array = prev.slice();
      array[current_index].pb_open = !prev[current_index].pb_open;
      return array;
    });
  };

  /**
   * 子の棚を作成
   * @param parent_id 親棚のid
   * @return JSX.Element[]
   */
  const createChildBlock = (parent_id: number) => {
    /** 口座区分の情報 */
    const account_type_param = contents.find((it) => {
      return it.fm_type === fm_types.account_type;
    });

    return child_shelfs.map((child_shelf) => {
      if (parent_id !== child_shelf.pb_id) {
        return;
      }
      switch (child_shelf.cb_kind) {
        case shelf_type.header: // ヘッダー01
          return (
            <TopArea
              key={child_shelf.key}
              reception_cd={reception_cd}
              is_staff={is_staff}
              status_name={status}
              email={email}
              application_date={application_date}
              application_product={application_product}
              user_name={user_name}
              user_kana_name={user_kana_name}
              status_code={status_code}
              receptionHitsoryCallback={(event) => clickReceptionHistory(event)}
              is_history={false}
              message={message}
              desired_amount_before={desired_amount_before}
              desired_amount_application={desired_amount_application}
              desired_amount_after={desired_amount_after}
            />
          );
        case shelf_type.shelf: // アコーディオン出力
        case shelf_type.account_transfer_info: // 口座振替情報
        case shelf_type.bank_account: // 銀行口座
        case shelf_type.ja_bank: // ゆうちょ銀行
        case shelf_type.customer_upload: // お客様アップロード
          return (
            <ShelfInShelf
              key={child_shelf.key}
              id={child_shelf.key}
              label={child_shelf.cb_display_name}
              is_open={child_shelf.cb_open}
              handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
            >
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </ShelfInShelf>
          );
        case shelf_type.account_holder: // 口座名義人
          if (account_type_param?.value !== '1') {
            // 口座振替情報 口座区分 が「既存」以外の場合表示する
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.layout_divisiton: // レイアウト用論理棚
          return (
            <LayoutDivision key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </LayoutDivision>
          );
        case shelf_type.fragment: // domを出力しない棚
          return (
            <React.Fragment key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </React.Fragment>
          );
        case shelf_type.footer: // 案件一覧に戻るボタン表示
          // マイページ未開設時は非表示
          // 変更があった場合のみダイアログを開く
          return (
            mypage_status_opened && (
              <FooterButtonShelf
                key={child_shelf.key}
                is_staff={is_staff}
                is_on_change={is_on_change}
              />
            )
          );
        case shelf_type.full_justify_buttons: // ボタン左右中央寄せ
          return (
            <RowFullJustifyButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowFullJustifyButton>
          );
        case shelf_type.left_button: // ボタン左寄せ
          return (
            <RowLeftButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowLeftButton>
          );
        case shelf_type.center_button: // ボタン中央寄せ
          return (
            <RowCenterButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowCenterButton>
          );
        case shelf_type.right_button: // ボタン右寄せ
          return (
            <RowRightButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowRightButton>
          );
        case shelf_type.justify_buttons: // ボタン均等割付
          return (
            <RowJustifyButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowJustifyButton>
          );
        case shelf_type.left_and_right_alignment_buttons: // ボタン左右揃え
          return (
            <RowLeftAndRightAlignmentButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowLeftAndRightAlignmentButton>
          );
        case shelf_type.left_and_center_alignment_buttons: // ボタン左中央配置
          return (
            <RowLeftAndCenterAlignmentButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowLeftAndCenterAlignmentButton>
          );
        default:
          return;
      }
    });
  };

  /**
   * 子棚を開閉する
   *
   * @param parent_id 親棚のid
   * @param child_id 子棚のid
   * @param is_open 開閉フラグ（true:開,false:閉）
   */
  const toggleChildShelf = (parent_id: number, child_id: number, is_open?: boolean) => {
    setChildShelfs((prev) => {
      // 対象子棚のindex取得
      const current_index = prev.findIndex(
        (value) => value.pb_id === parent_id && value.cb_id === child_id
      );
      // 対象子棚の開閉状態を設定
      const cb_open = typeof is_open === 'undefined' ? !prev[current_index].cb_open : is_open;
      // ディープコピー
      const array = prev.slice();
      array[current_index].cb_open = cb_open;
      return array;
    });
  };

  /**
   * 小の棚内に表示する要素を決定
   * @param pb_id 親の棚のid
   * @param cb_id 子の棚のid
   * @return JSX.Element[]
   */
  const createContents = (pb_id: number, cb_id: number) => {
    const tmp_year: Content[] = [tmp_init];
    const tmp_sei: Content[] = [tmp_init];
    return contents.map((content, index) => {
      if (cb_id !== content.cb_id || pb_id !== content.pb_id) {
        return;
      }
      switch (content.fm_type) {
        case fm_types.text: // テキストボックス表示
        case fm_types.number: // 数字入力欄表示
          return (
            <Text
              key={`${content.key}-${index}`}
              id={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              placeholder={content.placeholder}
              value={content.value}
              need={content.required_mark}
              message={content.message}
              name={content.field_column_name}
              suffix={content.suffix}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
              add_comma={content.input_assistance === convert_types.add_comma ? true : false}
              input_assistance={content.input_assistance}
            />
          );
        case fm_types.date: // Datepicker表示
          return (
            <RowDate
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              message={content.message}
              value={
                content.value !== null && content.value !== ''
                  ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                  : null
              }
              name={content.field_column_name}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              disabled={content.disabled}
              min_date={content.min_date ? new Date(content.min_date) : null}
              max_date={content.max_date ? new Date(content.max_date) : null}
            />
          );
        case fm_types.business_date: // BusinessDayCalendar表示（申込人：借入希望日）
          return (
            <BusinessDayCalendar
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              message={content.message}
              value={
                content.value !== null && content.value !== ''
                  ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                  : null
              }
              name={content.field_column_name}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.button: // ボタン表示
        case fm_types.postcode: // 郵便番号表示
          return (
            <Postcode
              id={content.key}
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              need={content.required_mark}
              value={content.value}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.text_with_search: // 検索項目つきテキストボックス
          return (
            <TextWithSearch
              id={content.key}
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              need={content.required_mark}
              value={content.value}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              readonly={true}
            />
          );
        case fm_types.tel: // 電話番号
          return (
            <Telnum
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              value={content?.value}
              need={content.required_mark}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.sei: // 姓
          tmp_sei[index] = content;
          break;
        case fm_types.mei: // 名
          return tmp_sei[index - 1]?.fm_id ? (
            <NameInput
              key={`${content.key}-${index}`}
              first_id={content.key}
              last_id={tmp_sei[index - 1].key}
              label={tmp_sei[index - 1].fm_display_name}
              need={content.required_mark}
              first_name={content.field_column_name}
              last_name={tmp_sei[index - 1].field_column_name}
              first_placeholder={content.placeholder}
              last_placeholder={tmp_sei[index - 1].placeholder}
              first_value={content.value}
              last_value={tmp_sei[index - 1].value}
              first_maxlength={content.maxlength}
              last_maxlength={tmp_sei[index - 1].maxlength}
              first_prefix={content.prefix}
              last_prefix={tmp_sei[index - 1].prefix}
              message={tmp_sei[index - 1].message ?? content.message}
              help_msg={content.help_msg}
              first_disabled={content.disabled}
              last_disabled={tmp_sei[index - 1].disabled}
            />
          ) : null;
        case fm_types.radio: // ラジオボタン
          return (
            <RadioButton
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.key} // Note tani.t 一意になる情報としてkey値を渡す
              value={content.value}
              sources={content.sources ?? []}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.checkbox: //チェックボックス
          return (
            <CheckBox
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources ?? []}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.select: // セレクトボックス
          return (
            <Select
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources ?? []}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              suffix={content.suffix}
            />
          );
        case fm_types.textarea: // テキストエリア
          return (
            <TextArea
              id={content.key}
              key={`${content.key}-${index}`}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              placeholder={content.placeholder}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
            />
          );
        case fm_types.paragraph: // Pタグ文章
          return (
            <Paragraph
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              color={content.color}
              bold={content.bold}
            />
          );
        case fm_types.center_paragraph: // Pタグ文章（中央表示）
          return (
            <CenterParagraph key={`${content.key}-${index}`} label={content.fm_display_name} />
          );
        case fm_types.paragraph2: // 囲み付き文字列
          return (
            <EnclosedString
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              color={content.color}
              bold={content.bold}
            />
          );
        case fm_types.year: // 年
          tmp_year[index] = content;
          break;
        case fm_types.month: // 月
          return tmp_year[index - 1]?.fm_id ? (
            <YearMonth
              key={`${content.key}-${index}`}
              year_id={tmp_year[index - 1].key}
              month_id={content.key}
              label={tmp_year[index - 1].fm_display_name}
              need={content.required_mark}
              year_name={tmp_year[index - 1].field_column_name}
              month_name={content.field_column_name}
              year_suffix={tmp_year[index - 1].suffix}
              month_suffix={content.suffix}
              year_placeholder={tmp_year[index - 1].placeholder}
              year={tmp_year[index - 1].value}
              month={content.value}
              year_maxlength={tmp_year[index - 1].maxlength}
              help_msg={tmp_year[index - 1].help_msg}
              year_disabled={tmp_year[index - 1].disabled}
              month_disabled={content.disabled}
              message={tmp_year[index - 1].message ?? content.message}
              sources={content.sources ?? []}
            />
          ) : null;
        case fm_types.image: // 画像
          return <Image key={`${content.key}-${index}`} value={content.value} />;
        case fm_types.file: // ファイルアップローダ
          return (
            <FileUploadTemplate
              key={`${content.key}-${index}`}
              files_upload={file_upload_list}
              setFilesUpload={setFileUploadList}
              block_disabled={content.disabled}
              fm_id={content.fm_id}
              is_staff={is_staff}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_id={reception_id}
              reception_cd={reception_cd}
              reception_sub_cd={reception_sub_cd}
              upload_token={upload_token}
            />
          );
        case fm_types.no_label_textarea: // ラベルなしテキストエリア
          return (
            <NoLabelTextarea
              id={content.key}
              key={`${content.key}-${index}`}
              fm_id={content.fm_id}
              name={content.field_column_name}
              value={content.value}
              placeholder={content.placeholder}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
            />
          );
        case fm_types.no_label_checkbox: // ラベルなしチェックボックス
          return (
            <NoLabelCheckBox
              key={`${content.key}-${index}`}
              id={content.key}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources ?? []}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              fm_id={content.fm_id}
            />
          );
        case fm_types.shelf_heading: // 棚内の見出し
          return <ShelfHeading label={content.fm_display_name} />;
        case fm_types.clause: // 同意文章
          return (
            <Clause
              id_name={`${content.key}-${index}`}
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              content={content.clause_content ?? ''}
              checked={content.value}
              disabled={content.disabled}
              check_box_title={content.check_box_title}
            />
          );
        default:
          break;
      }
    });
  };

  /**
   * 入力履歴ボタンを押下する
   */
  const clickReceptionHistory = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    window.open(
      `${location.origin}${process.env.MIX_MOCK_URL}/staff/history/${reception_cd}`,
      '_blank',
      'top=0,left=0,left=0,width=600,height=600,resizable=yes'
    );
  };

  return (
    <>
      {contents.length !== 0 && createParentBlock()}

      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};

const div = document.getElementById('main');
if (div) {
  //Receptionコンポーネント専用のIE対応用クラスを付与する。
  div.classList.add(isBrowserIe() ? 'ie' : 'no-ie');
}

const container = document.getElementById('reception_detail');
if (container) {
  const root = createRoot(container);
  root.render(<ReceptionDetail />);
}
